import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { Setting } from "../models/Setting";

// UTL.SetSetting takes the current name to find the row and the new one to store, which is how it
// renames a setting. On create there is no previous name, so both carry the same value and the
// procedure falls through to the INSERT. catSettings is keyed by name: there is no SettingId column.
export const upsertSettings = async (
	{ Description, SettingName, Value }: Setting,
	oldName?: string,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "OldName", value: oldName ?? SettingName });
	parameters.push({ name: "NewName", value: SettingName });
	parameters.push({ name: "Description", value: Description });
	parameters.push({ name: "Value", value: Value });

	const resp = await apiService.callV2("[UTL].[SetSetting]", parameters);
	return resp;
};

export const deleteSetting = async (SettingName: string) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "SettingName", value: SettingName });

	const resp = await apiService.callV2("[UTL].[DeleteSetting]", parameters);
	return resp;
};
